import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import isEqual from "react-fast-compare";
import { useTableView } from "../TableViewContext";
export const TABLE_ROW_LEFT_PADDING = 16;
export const DesktopTableRowContainer = /*#__PURE__*/ memo((param)=>{
    let { className, style, ...restProps } = param;
    const { getTableWidthStyle } = useTableView();
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("flex-1 [&_.table-cell]:px-2 [&_.table-cell]:py-2 [&_.tableRow]:-mr-4 [&_.tableRow]:rounded-4", className),
        style: {
            marginLeft: "-".concat(TABLE_ROW_LEFT_PADDING, "px"),
            ...style,
            ...getTableWidthStyle()
        },
        ...restProps
    });
}, isEqual);
DesktopTableRowContainer.displayName = "TableViewRow";
